/* DefinitionsDropdownMenu.tsx generated by @compiled/babel-plugin v0.38.1 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _excluded = ["triggerRef"];
import "./DefinitionsDropdownMenu.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useEffect, useState } from 'react';
import { defineMessages, useIntl } from 'react-intl-next';
import { IconButton } from '@atlaskit/button/new';
import DropdownMenu from '@atlaskit/dropdown-menu';
import Heading from '@atlaskit/heading';
import ShowMoreHorizontalIcon from '@atlaskit/icon/core/show-more-horizontal';
import { Box, Inline, Stack, Text } from '@atlaskit/primitives/compiled';
import Toggle from '@atlaskit/toggle';
import { deleteSessionItem, getSessionItem, setSessionItem } from '@atlassian/search-dialog';
import { useAIAnswerContext } from '../../../../ai-answer-dialog/ai-answer-context';
import { EditDefinition } from '../../../../ai-answer-dialog/definition-answer-card/edit-definition';
import { onClickDisableDefinition } from '../../analytics';
import { toggleDefinitionErrorPayload } from '../../error-analytics';
import { useToggleDefinitionSupplier } from '../../footer/useToggleDefinitionSupplier';
var AI_DEFINITION_TOGGLE_CACHE_KEY = 'atlassian.search-ai.ai-definition-toggle';
var messages = defineMessages({
  // messages to disable ALL definitions
  disable_definitions_more_icon_tooltip: {
    id: 'search_ai.disable_definitions_more_icon_tooltip',
    defaultMessage: 'See more actions',
    description: 'Tooltip for definition more icon'
  },
  disable_definitions_header: {
    id: 'search_ai.disable_definitions_header',
    defaultMessage: 'Don’t recommend definitions at all',
    description: 'Header text for definitions menu option to disable autohighlighting'
  },
  disable_definitions_description: {
    id: 'search_ai.disable_definitions_description',
    defaultMessage: 'When this is on, we’ll no longer automatically highlight terms and acronyms on any page. Only you will see these changes.',
    description: 'Description text for the reading aids menu option to not disable auto highlighting'
  },
  // messages to disable SINGLE definition
  disable_definition_term_header: {
    id: 'search_ai.disable_definition_term_header',
    defaultMessage: 'Don’t recommend this term',
    description: 'Header text for definitions menu option to disable autohighlighting for this single term'
  },
  disable_definition_term_description: {
    id: 'search_ai.disable_definition_term_description',
    defaultMessage: 'When this is on, we’ll no longer automatically highlight this specific term on any page. Only you will see these changes.',
    description: 'Description text for the reading aids menu option to disable single term'
  }
});
var MoreIconStyled = function MoreIconStyled() {
  return /*#__PURE__*/React.createElement(ShowMoreHorizontalIcon, {
    label: "definitions-disable-menu-button-icon",
    color: "var(--ds-icon-subtle, #505258)"
  });
};
var styles = {
  root: "_1bsb3xl8 _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
  dividerStyles: "_15a5nqa1 _uwhke4h9 _1i531l7x"
};
export var DefinitionsDropdownMenu = function DefinitionsDropdownMenu() {
  var _useAIAnswerContext = useAIAnswerContext(),
    commonAttributes = _useAIAnswerContext.commonAttributes,
    definitionToggleEnabled = _useAIAnswerContext.definitionToggleEnabled,
    fireAnalyticsEvent = _useAIAnswerContext.fireAnalyticsEvent,
    readingAidsOptions = _useAIAnswerContext.readingAidsOptions,
    sourceProduct = _useAIAnswerContext.sourceProduct;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    definitionsDropdownMenuOpen = _useState2[0],
    setDefinitionsDropdownMenuOpen = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    disableDefinitions = _useState4[0],
    setDisableDefinitions = _useState4[1];

  // the localStorage method to track whether all Definitions are disabled is different
  // between products so we need to get from the product whether Definitions have already been disabled by user
  useEffect(function () {
    var _readingAidsOptions$d;
    var definitionsDisabled = !!(readingAidsOptions !== null && readingAidsOptions !== void 0 && (_readingAidsOptions$d = readingAidsOptions.disableDefinitionsCallbacks) !== null && _readingAidsOptions$d !== void 0 && _readingAidsOptions$d.getDefinitionsDisabled());
    setDisableDefinitions(definitionsDisabled);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var disableDefinitionsCallbacks = readingAidsOptions === null || readingAidsOptions === void 0 ? void 0 : readingAidsOptions.disableDefinitionsCallbacks;

  // need to account for non-platformized version
  var _ref = readingAidsOptions || {},
    readingAidsMenuOptions = _ref.menuOptions;
  var cloudId = commonAttributes.cloudId,
    keyPhrase = commonAttributes.query,
    workspaceId = commonAttributes.workspaceId;
  var cachedDefinitionTermDisabled = JSON.parse(getSessionItem(AI_DEFINITION_TOGGLE_CACHE_KEY) || '{}');
  var _useState5 = useState(cachedDefinitionTermDisabled.keyPhrase === keyPhrase),
    _useState6 = _slicedToArray(_useState5, 2),
    disableDefinitionTerm = _useState6[0],
    setDisableDefinitionTerm = _useState6[1];
  var _useToggleDefinitionS = useToggleDefinitionSupplier(),
    toggleDefinition = _useToggleDefinitionS.toggleDefinition;
  var onToggleDefinitionTermDisable = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            setDisableDefinitionTerm(function (current) {
              return !current;
            });
            _context.next = 4;
            return toggleDefinition({
              workspaceId: workspaceId,
              keyPhrase: keyPhrase,
              isDisabled: !disableDefinitionTerm,
              cloudId: cloudId,
              product: sourceProduct !== null && sourceProduct !== void 0 ? sourceProduct : ''
            });
          case 4:
            if (disableDefinitionTerm) {
              deleteSessionItem(AI_DEFINITION_TOGGLE_CACHE_KEY);
            } else {
              fireAnalyticsEvent(onClickDisableDefinition(commonAttributes));
              setSessionItem(AI_DEFINITION_TOGGLE_CACHE_KEY, JSON.stringify({
                keyPhrase: keyPhrase
              }));
            }
            _context.next = 11;
            break;
          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            setDisableDefinitionTerm(function (current) {
              return !current;
            });
            fireAnalyticsEvent(toggleDefinitionErrorPayload(_context.t0, commonAttributes));
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 7]]);
    }));
    return function onToggleDefinitionTermDisable() {
      return _ref2.apply(this, arguments);
    };
  }();
  var _ref3 = readingAidsOptions || {},
    definitionCurationOptions = _ref3.definitionCurationOptions;
  var editDefinitionEnabled = !!definitionCurationOptions;
  return /*#__PURE__*/React.createElement(DropdownMenu, {
    isOpen: definitionsDropdownMenuOpen,
    trigger: function trigger(_ref4) {
      var triggerRef = _ref4.triggerRef,
        props = _objectWithoutProperties(_ref4, _excluded);
      return /*#__PURE__*/React.createElement(IconButton, _extends({}, props, {
        appearance: "subtle",
        icon: MoreIconStyled,
        ref: triggerRef,
        onClick: function onClick() {
          setDefinitionsDropdownMenuOpen(!definitionsDropdownMenuOpen);
        },
        testId: "definitions-menu-button",
        label: "definitions-menu-button"
      }));
    },
    shouldRenderToParent: true
  }, /*#__PURE__*/React.createElement(Stack, {
    xcss: styles.root,
    space: "space.100"
  }, disableDefinitionsCallbacks && /*#__PURE__*/React.createElement(Stack, {
    space: "space.100"
  }, /*#__PURE__*/React.createElement(Inline, {
    alignBlock: "center",
    spread: "space-between"
  }, /*#__PURE__*/React.createElement(Heading, {
    size: "xxsmall"
  }, formatMessage(messages.disable_definitions_header)), /*#__PURE__*/React.createElement(Toggle, {
    onChange: function onChange() {
      if (disableDefinitions) {
        disableDefinitionsCallbacks.onEnableDefinitions();
      } else {
        disableDefinitionsCallbacks.onDisableDefinitions();
      }
      setDisableDefinitions(!disableDefinitions);
    },
    isChecked: disableDefinitions,
    testId: "definitions-toggle-disable"
  })), /*#__PURE__*/React.createElement(Text, {
    color: "color.text.subtle",
    size: "small"
  }, formatMessage(messages.disable_definitions_description))), readingAidsMenuOptions && readingAidsMenuOptions.length > 0 && readingAidsMenuOptions.map(function (option) {
    return /*#__PURE__*/React.createElement(Stack, {
      space: "space.100"
    }, /*#__PURE__*/React.createElement(Inline, {
      alignBlock: "center",
      spread: "space-between"
    }, /*#__PURE__*/React.createElement(Heading, {
      size: "xxsmall"
    }, formatMessage(messages.disable_definitions_header)), /*#__PURE__*/React.createElement(Toggle, {
      onChange: option.onChange,
      isChecked: option.toggleState,
      testId: "definitions-toggle-disable"
    })), /*#__PURE__*/React.createElement(Text, {
      color: "color.text.subtle",
      size: "small"
    }, formatMessage(messages.disable_definitions_description)));
  }), definitionToggleEnabled && /*#__PURE__*/React.createElement(Stack, {
    space: "space.100"
  }, /*#__PURE__*/React.createElement(Box, {
    xcss: styles.dividerStyles
  }), /*#__PURE__*/React.createElement(Inline, {
    alignBlock: "center",
    spread: "space-between"
  }, /*#__PURE__*/React.createElement(Heading, {
    size: "xxsmall"
  }, formatMessage(messages.disable_definition_term_header)), /*#__PURE__*/React.createElement(Toggle, {
    onChange: onToggleDefinitionTermDisable,
    isChecked: disableDefinitionTerm,
    testId: "definition-term-toggle-disable"
  })), /*#__PURE__*/React.createElement(Text, {
    color: "color.text.subtle",
    size: "small"
  }, formatMessage(messages.disable_definition_term_description))), editDefinitionEnabled && /*#__PURE__*/React.createElement(Stack, {
    space: "space.100"
  }, /*#__PURE__*/React.createElement(Box, {
    xcss: styles.dividerStyles
  }), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(EditDefinition, {
    onClose: function onClose() {
      return setDefinitionsDropdownMenuOpen(false);
    }
  })))));
};